import styled from "styled-components";

export const AnimatedMapContainer = styled.div`
  overflow: hidden;
  transition: opacity 0.4s ease, transform 0.4s ease, max-height 0.4s ease;
  opacity: ${({ show }) => (show ? 1 : 0)};
  transform: ${({ show }) => (show ? "translateY(0px)" : "translateY(16px)")};
  max-height: ${({ show }) => (show ? "600px" : "0")};
  pointer-events: ${({ show }) => (show ? "auto" : "none")};
`;
